import { Component, OnInit } from '@angular/core';
import { CooperationService } from '../../services/cooperation-services';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { AddCooperationComponent } from '../add-cooperation/add-cooperation.component';
import { CooperationDetailsComponent } from '../cooperation-details/cooperation-details.component';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-get-cooperation',
  templateUrl: './get-cooperation.component.html',
  styleUrls: ['./get-cooperation.component.scss']
})
export class GetCooperationComponent  extends BaseComponent implements OnInit {

  form:FormGroup

  constructor(
    public service: CooperationService,
    route: Router,
    private fb:FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService
  ) {
    super(route, service, null);
  }


  ngOnInit() {
    this.initForm();
    this.loadEntities();
  }
initForm(){
  this.form = this.fb.group({
    nameAR: ['']
  });
}


clearFilter(){
  this.form.controls['nameAR'].setValue('');
  this.loadEntitiesWithFilter('')
}

handleSearch(){  

  if(!this.form.value.nameAR.trim()){
    this.toast.danger('برجاءاختيار الاسم لاتمام عملية البحث', 'رساله تحذيرية');
  return
  }

  if(this.form.value.nameAR){ 
    const name = this.form.value.nameAR.trim();
    this.form.controls['nameAR'].setValue(name);
  this.loadEntitiesWithFilter(`nameAR:${name}`)
}}


  addNew() {
    this.diag
      .open(AddCooperationComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

  delete(id) {
    this.service.delete(id).subscribe((res) => {
      this.loadEntities();
      this.toast.show('تم الحذف بنجاح', '', { status: 'success', duration: 3000 });
    });
  }

  detail(model) {
    this.diag.open(CooperationDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddCooperationComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
